import { api } from "../Apis/interceptor";

export const get = function (id, cust_id, branch) {
  return api.get(
    "/api/v1/clients/" +
    id +
    "/" +
    cust_id +
    "/" +
    branch.branch_id +
    "/" +
    branch.branch_key
  );
};

export const all = function (
  cust_id,
  branch,
  sortBy,
  orderBy,
  filterData,
  page
) {
  return api.get("/api/v1/clients", {
    params: {
      cust_id: cust_id,
      branchId: branch.branch_id,
      branchKey: branch.branch_key,
      sortBy: sortBy,
      orderBy: orderBy,
      main_board_sponsor: filterData.main_board_sponsor,
      filter: filterData.filter,
      client_classification: filterData.client_classification,
      client_type: filterData.client_type,
      relationship_owner: filterData.relationship_owner,
      sector: filterData.sector,
      client_status: filterData.stakeholder_status,
      business_units_involved: filterData.business_unit,
      page: page,
    },
  });
};

export const filter = function (
  skip,
  limit,
  cust_id,
  branch,
  pattern,
  sortBy,
  orderBy,
  filterData,
  searchVal
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/clients_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      branchId: branch.branch_id,
      branchKey: branch.branch_key,
      pattern: pattern,
      sortBy: sortBy,
      orderBy: orderBy,
      filterBranch: JSON.stringify(filterData.branch_id),
      client_classification: JSON.stringify(filterData.client_classification),
      relationship_owner: JSON.stringify(filterData.relationship_owner),
      client_type: JSON.stringify(filterData.client_type),
      sector: JSON.stringify(filterData.sector),
      filter: filterData.filter,
      client_status: JSON.stringify(filterData.stakeholder_status),
      business_units_involved: JSON.stringify(filterData.business_unit),
      region: JSON.stringify(filterData.region),
      main_board_sponsor: JSON.stringify(filterData.main_board_sponsor),
      client_type: JSON.stringify(filterData.client_type),
      searchVal: searchVal,
    },
  });
};

// export const bySeqId = function(searchVal, cust_id, branch, sortBy, orderBy, filterData) {
//     return api.get('/api/v1/clients/bySeqId', { params: { searchVal: searchVal, cust_id: cust_id, branchId: branch.branch_id, branchKey: branch.branch_key, sortBy: sortBy, orderBy: orderBy, client_classification: filterData.client_classification, client_type: filterData.client_type } });
// };

// export const getPageLike = function(cust_id, branch, pattern, sortBy, orderBy, filterData) {
//     return api.get('/api/v1/clientsLike', { params: { cust_id: cust_id, branchId: branch.branch_id, branchKey: branch.branch_key, pattern: pattern, sortBy: sortBy, orderBy: orderBy, client_classification: filterData.client_classification, client_type: filterData.client_type } });
// };
export const goalClientComplete = function (
  client_id,
  cust_id,
  parentIndex,
  index
) {
  return api.put("/api/v1/clientActionComplete/" + cust_id, {
    client_id: client_id,
    parentIndex: parentIndex,
    index: index,
  });
};

export const findFrom = function (framework_id) {
  return api.get("/api/v1/clientsfrom/" + framework_id);
};

export const create = function (userData) {
  return api.post("/api/v1/clients/", userData);
};

export const update = function (id, userData) {
  return api.put("/api/v1/clients/" + id, userData);
};

export const delete1 = function (id) {
  return api.delete("/api/v1/clients/" + id);
};

export const multiDelete = function (ids, cust_id) {
  return api.delete("/api/v1/clientMultiDelete", {
    params: {
      id: ids,
      cust_id: cust_id,
    },
  });
};

export const deletefw = function (client_id, framework_id) {
  return api.get("/api/v1/framework/" + client_id + "/" + framework_id);
};

export const getNext = function (id, cust_id) {
  return api.get("/api/v1/clientNext/" + id + "/" + cust_id);
};

export const getPrevious = function (id, cust_id) {
  return api.get("/api/v1/clientPrev/" + id + "/" + cust_id);
};

export const getSeq = function (cust_id) {
  return api.get("/api/v1/clientId/" + cust_id);
};
export const members = function (cust_id, clt_name) {
  return api.get("/api/v1/clientTeamList/" + cust_id + "/" + clt_name);
};

export const getClientContactList = function (
  id,
  cust_id,
  skip,
  limit,
  searchClientByContact
) {
  return api.get("/api/v1/getClientContactList", {
    params: {
      id: id,
      cust_id: cust_id,
      skip: skip,
      limit: limit,
      searchClientByContact: searchClientByContact,
    },
  });
};

export const addClientTeam = function (
  id,
  cust_id,
  client_name,
  clientContactForm
) {
  return api.put(
    "/api/v1/addClientTeam/" + id + "/" + cust_id + "/" + client_name,
    clientContactForm
  );
};

export const updateClientTeam = function (id, editClientContactForm) {
  return api.put("/api/v1/updateClientTeam/" + id, editClientContactForm);
};

export const deleteClientTeam = function (contact_id) {
  return api.put("/api/v1/deleteClientTeam/" + contact_id);
};

export const getClientAddressList = function (
  id,
  cust_id,
  add_skip,
  add_limit,
  searchClientByAddress
) {
  return api.get("/api/v1/getClientAddressList", {
    params: {
      id: id,
      cust_id: cust_id,
      skip: add_skip,
      limit: add_limit,
      searchClientByAddress: searchClientByAddress,
    },
  });
};

export const addClientAddress = function (
  id,
  cust_id,
  client_name,
  clientAddressForm
) {
  return api.put(
    "/api/v1/addClientAddress/" + id + "/" + cust_id + "/" + client_name,
    clientAddressForm
  );
};

export const updateClientAddress = function (
  id,
  cust_id,
  editClientAddressForm
) {
  return api.put(
    "/api/v1/updateClientAddress/" + id + "/" + cust_id,
    editClientAddressForm
  );
};

export const deleteClientAddress = function (clAddress_Id) {
  return api.put("/api/v1/deleteClientAddress/" + clAddress_Id);
};

export const saveCRDScoreBox = function (cust_id, winScoreLabel) {
  return api.put("/api/v1/saveWinscoreBoxLabelsClient/" + cust_id, {
    winScoreLabel: winScoreLabel,
  });
};

// export const saveClientAddress = function(id, cust_id, clientAddress) {
//     return api.put('/api/v1/saveClientAddress/' + id + "/" + cust_id, clientAddress);
// };

export const updateClientPlanSection = function (
  id,
  cust_id,
  clientTacticData
) {
  return api.put(
    "/api/v1/updateClientPlanSection/" + id + "/" + cust_id,
    clientTacticData
  );
};

export const generateCPlan = function (id, cust_id) {
    window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/generateCPlan?client_id=${id}&cust_id=${cust_id}`);
};


export const getClientId = function (client_name) {
  return api.get("/api/v1/clientIdByName/" + client_name);
};

export const exportClientContact = (id, cust_id) => {
  window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/exportClientContact?client_id=${id}&cust_id=${cust_id}`);
};

//save client data from survey
export const approveClient = function (suvey_cus_id, clientData) {
  return api.put("/api/v1/approveClient/" + suvey_cus_id, {
    clientData: clientData,
  });
};

export const getCustomerDetails = function (cust_id) {
  return api.get("/api/v1/customerDetails/" + cust_id);
};

export const getSeqInLogs = function (cust_id) {
  return api.get("/api/v1/clientLogId/" + cust_id);
};

export const createLogs = function (userData) {
  return api.post("/api/v1/clientLogs/", userData);
};

export const getLogsTable = function (client_id) {
  return api.get("/api/v1/clientLogData/" + client_id);
};

export const getLogTablesByDate = function (date) {
  return api.get("/api/v1/clientLogDataByDate/" + date);
};

export const getClientData = function (cust_id, branch) {
  return api.get(
    "/api/v1/clients/" +
    cust_id +
    "/" +
    branch[0]._id +
    "/" +
    branch[0].branch_key
  );
};

export const findFromStake = function (client_id) {
  return api.get("/api/v1/clientsfromStake/" + client_id);
};

export const deletestake = function (client_id, id) {
  return api.get("/api/v1/stakeholders/" + client_id + "/" + id);
};

export const updateStakeholder = function (clientId, stakeId) {
  return api.put("/api/v1/updateStakeholder/" + clientId + "/" + stakeId);
};

export const overviewClientOpps = function(client_id, cust_id,flag) {
  return api.get('/api/v1/overviewClientOpps/' + client_id + "/" + cust_id + "/" +flag);
};

export const getCustomerTable = function(cust_id) {
  return api.get('/api/v1/customerTable/' + cust_id);
};

export const getClientOpportunity = function(client_id, cust_id) {
  return api.get('/api/v1/clientOpportunity/' + client_id + "/" + cust_id);
};
